document.querySelectorAll(".productCard__fav").forEach(item => {
  item.addEventListener('click', function (e) {
    e.stopPropagation()
    e.preventDefault()
    if (this.classList.contains("productCard__fav--active")) {
      this.classList.remove('productCard__fav--active')
    } else {
      this.classList.add('productCard__fav--active')
    }
  })
})

document.querySelectorAll(".productCard__bask").forEach(item => {
  item.addEventListener("click", function (e) {
    e.stopPropagation()
    e.preventDefault()
    console.log(this.textContent == 'В корзину')
    if(!this.classList.contains('add')){
      this.textContent = 'В корзине'
      this.classList.add('add')
    } else{
      this.textContent = 'В корзину'
      this.classList.remove('add')
    }
    // this.closest('.productCard__btnsWr').querySelector(".productCard__baskNm").classList.add('active')
  })
})

document.querySelectorAll(".productCard__baskMin").forEach(item => {
  item.addEventListener("click", function (e) {
    e.stopPropagation()
    e.preventDefault()
    if (this.closest('.productCard__baskNm').querySelector(".productCard__baskCount span").textContent == 1) {
      this.closest('.productCard__baskNm').classList.remove('active')
      this.closest('.productCard__btnsWr').querySelector(".productCard__bask").classList.add('active')
    } else {
      this.closest('.productCard__baskNm').querySelector('.productCard__baskCount span').textContent = Number(this.closest('.productCard__baskNm').querySelector('.productCard__baskCount span').textContent) - Number(1)
    }
  })
})

document.querySelectorAll(".productCard__baskPl").forEach(item => {
  item.addEventListener("click", function (e) {
    e.stopPropagation()
    e.preventDefault()
    this.closest('.productCard__baskNm').querySelector('.productCard__baskCount span').textContent = Number(this.closest('.productCard__baskNm').querySelector('.productCard__baskCount span').textContent) + Number(1)
  })
})

document.querySelectorAll(".productCard__btnsWr").forEach(item => {
  item.addEventListener("click", function (e) {
    e.stopPropagation()
    e.preventDefault()
  })
})

document.querySelectorAll(".product__baskMin").forEach(item => {
  item.addEventListener("click", function (e) {
    e.stopPropagation()
    e.preventDefault()
    if (this.closest('.product__baskNm').querySelector(".product__baskCount span").textContent == 1) {
      this.closest('.product__baskNm').classList.remove('active')
      this.closest('.product__content').querySelector(".product__btnBask ").classList.remove('active')
      this.closest('.product__content').querySelector(".product__btnBask ").textContent = "В корзину"
    } else {
      this.closest('.product__baskNm').querySelector('.product__baskCount span').textContent = Number(this.closest('.product__baskNm').querySelector('.product__baskCount span').textContent) - Number(1)
    }
  })
})

document.querySelectorAll(".product__baskPl").forEach(item => {
  item.addEventListener("click", function (e) {
    e.stopPropagation()
    e.preventDefault()
    this.closest('.product__baskNm').querySelector('.product__baskCount span').textContent = Number(this.closest('.product__baskNm').querySelector('.product__baskCount span').textContent) + Number(1)
  })
})

document.querySelector(".product__btnBask")?.addEventListener('click', function(e){
  if(!this.closest('active')){
    this.classList.add('active')
    document.querySelector('.product__baskNm').classList.add("active")
  }
})

document.querySelector(".product__listAll")?.addEventListener("click", function(e){
  if(this.textContent == 'Развернуть'){
    this.textContent = 'Свернуть'
    document.querySelector('.product__listNal').classList.add('active')
  } else{
    this.textContent = 'Развернуть'
    document.querySelector('.product__listNal').classList.remove('active')
  }
})